import { Button, DateInput, Input, Label, Modal, ApprovalAlert } from "components";
import moment from "moment";
import { Fragment, useState } from "react";
import toast from "react-hot-toast";
import { IoSendSharp } from "react-icons/io5";
import { useApi, useHandleAuth, useToggle } from "utils";
import { DetailOpeningStock } from "../../OpeningStock/components/ActionSection/Detail";
import { ApproveType } from "../types";


export function ApproveAction(props: {
  data: ApproveType
  refetch: () => void
}) {
  const { isActive, toggle } = useToggle(false)

  return (
    <Fragment>
      <Button
        type="button"
        color="ghost"
        permission={"IT151"}
        onClick={toggle}
        disabled={Boolean(props?.data?.approve_status === 3 || props?.data?.approve_status === 4)}
      >
        <IoSendSharp />
      </Button>
      {isActive && <ModalSection toggle={toggle} data={props.data} refetch={props.refetch} />}
    </Fragment>
  )
}

function ModalSection(props: {
  toggle: () => void,
  data: ApproveType
  refetch: () => void
}): JSX.Element {
  const api = useApi()
  const [date, setDate] = useState<string>(moment().format("YYYY-MM-DD"))
  const { userTokenData } = useHandleAuth()
  const userToken: any = userTokenData()
  

  const onSubmit = (date: string | undefined, status: number) => {

    return new Promise<void>((resolve) => {
      toast.promise(
        api.post(`/opening-stock/approve?opening_stock_id=${props.data.opening_stock_id}&approval_status=${status}&approve_date=${date}`),
        {
          loading: "Loading...",
          success: (res) => res.data.message,
          error: (err) => err.response.data.message ?? err.response.message
        }
      ).then(() => {
        props.toggle()
        props?.refetch && props.refetch()
      }).catch(() => { }).finally(resolve)
    })
  }

  return (
    <Modal
      isdarktitle
      isOpen
      title="APPROVAL OPENING STOCK"
      closeModal={props.toggle}
    >
      <Modal.Body>
        <div className="mb-2">
          <DetailOpeningStock opening_stock_id={props.data.opening_stock_id} />
        </div>
        <div>
          <div>
            <Label text="APPROVE BY"/>
            <Input 
              disabled
              value={userToken?.employee_name}
              className="w-[200px]"
            />
          </div>
        </div>
      </Modal.Body>

      <Modal.Footer className="flex md:flex-row flex-col justify-between md:items-end gap-3">
        <DateInput
          placeholderText="Select Date"
          selected={moment(date).toDate()}
          className="w-full"
          label="APPROVAL DATE"
          onChange={(date) => {
            const selectDate = moment(date).format("YYYY-MM-DD")
            setDate(selectDate)
          }}
        />

        <section className="flex gap-3">
          <Button onClick={props.toggle}>CANCEL</Button>
          <Button color="error" onClick={() => onSubmit(date, 3)}>VOID</Button>
          <Button color="primary" 
            onClick={() => {
              if(props.data.transaction_date !== date){
                ApprovalAlert("Approval date is different from transaction date").then(async (res) => {
                  if (res.isConfirmed) {
                    onSubmit(date, 4)
                  }else{
                    return
                  }
                })
              }else{
                onSubmit(date, 4)
              }  
            }}
          >
              APPROVE
          </Button>
        </section>
      </Modal.Footer>

    </Modal>
  )
}

